export default [
  {
    path: "/formasPago",
    component: () => import("@/views/formasPago/Listar.vue"),
  },
  {
    path: "/formasPago/crear",
    component: () => import("@/views/formasPago/Crear.vue"),
  },
  {
    path: "/formasPago/editar/:id",
    component: () => import("@/views/formasPago/Editar.vue"),
  },
];
